(ns bec-cljs-common.i18n
  (:refer-clojure :exclude [get])
  (:require [taoensso.timbre :as log]
            [cljs.pprint :refer [cl-format]]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [clojure.string :as s]
            [ajax.core :as ajax]
            [cljs.reader :as reader]))

(rf/reg-sub :locale
  (fn [db _]
    (or (-> db :bec-clj-common :i18n :locale) ;; User defined; override.
        (-> db :config :locale) ;; Config fallback.
        "en-US"))) ;; Fallback for the fallback; useful when the app hasn't been initialized at all yet.


(defonce locale-sub (rf/subscribe [:locale])) ;; NOTE: Application code should `set!` this!


(defonce translations (r/atom {}))


(defn import! "Loads translations from `uri` and resets the `translations` ratom.
  `on-loaded` (fn [] ..): Called when translations have been loaded."
  [uri on-loaded]
  (ajax/GET uri
            :handler #(do
                        (->> (reader/read-string %)
                             (reduce (fn [m [path entry]]
                                       (assoc-in m path entry))
                                     {})
                             (reset! translations))
                        (on-loaded))
            :error-handler #(log/fatal %)))


(defn get "`path-args`: [:welcome] or [[:welcome] \"Lars\"].
  `opts`: `:locale`: string or re-frame sub containing: \"nb-NO\", \"en-US\" etc..
          `:translations`: map, re-frame sub or ratom containing map.
          `:resolve-phrase?`: If false (default is true), returns the raw translation data (map) instead of resolving and rendering it to final output String."
  ([path-args]
   (get nil path-args))

  ([opts path-args]
   (let [resolve-phrase? (if (contains? opts :resolve-phrase?)
                           (:resolve-phrase? opts)
                           true)
         fallback-phrase (:fallback-phrase opts)
         path (if (vector? (first path-args))
                (first path-args) ;; [[:welcome] "Lars"]
                path-args) ;; [:welcome]
         args (if (vector? (first path-args))
                (rest path-args)
                nil)
         locale (let [res (or (:locale opts) @locale-sub)]
                  (if (string? res)
                    res
                    (try @res (catch :default ex (log/fatal ex) "en-US"))))
         translations (let [res (or (:translations opts) @translations)]
                        (if (map? res)
                          res
                          (try @res (catch :default ex (log/fatal ex) nil))))
         phrase (if resolve-phrase?
                  (or (-> (get-in translations (conj path locale) fallback-phrase) ;; TODO: Define more fallbacks here or in a helper Fn
                          (not-empty))
                      ;; E.g. nn-NO -> nb-NO.
                      (do
                        #_(log/warn (ex-info "Using fallback translation." {:locale locale, :path path}))
                        (get-in translations (conj path "en-US")))
                      (do
                        (log/fatal (ex-info "Translation phrase not found." {:locale locale, :path path}))
                        (str "#" path "#")))
                  (get-in translations path nil))]
     (if resolve-phrase?
       (try (apply cl-format nil phrase args)
            (catch :default ex
              (log/fatal ex {:locale locale, :path path, :phrase phrase, :args args})
              phrase))
       phrase))))


(defn locale->country-code [locale]
  (when-let [country-code (when locale (second (s/split locale #"-")))]
    (s/lower-case country-code)))


(defn locale->language-code [locale]
  (when-let [language-code (when locale (first (s/split locale #"-")))]
    (s/lower-case language-code)))
